
import { Vue, Options } from "vue-class-component";
import CardDashboardClient from "@/app/ui/views/dashboard/component/client/component/card-dashboard-client.vue";
import DetailStatusCardDashboardClient from "@/app/ui/views/dashboard/component/client/component/detail-status-card-dashboard-client.vue";
import ProgressBar from "@/app/ui/components/progress-bar/index.vue";
import { DashboardController } from "@/app/ui/controllers/DashboardController";
import { DataCorporateDashboard } from "@/domain/entities/Dashboard";
import checkRolePermission from "@/app/infrastructures/misc/common-library/CheckRolePermission";
import { TRACK_DELIVERY } from "@/app/infrastructures/misc/RolePermission";
import { IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Constants";

@Options({
  components: {
    DetailStatusCardDashboardClient,
    CardDashboardClient,
    ProgressBar
  }
})
export default class CodValueCard extends Vue {
  async mounted() {
    await this.fetchDataTotalCodValue();
    await this.fetchDataCodValue();
  }
  async fetchDataTotalCodValue() {
    this.totalCodValue.tooltip = this.buildTooltip(
      "dashboard.codValue.tooltipEstTotalCodValue.list1",
      "dashboard.codValue.tooltipEstTotalCodValue.list2"
    );
    if (this.deliveryType === "non_cod") {
      this.totalCodValue.amount = 0;
      this.totalCodValue.resi = 0;
      return;
    }
    this.totalCodValue.loading = true;
    const response = await DashboardController.getCorporateDashboardDeliveryData(
      {
        path: "/cod/status",
        sttCategory: "all",
        deliveryType: "cod",
        cache: true
      }
    );
    this.totalCodValue.amount = response.totalCodAmount;
    this.totalCodValue.resi = response.totalStt;
    this.totalCodValue.loading = false;
  }
  async fetchDataCodValue() {
    this.codValuePerStatus[0].tooltip = this.buildTooltip(
      "dashboard.codValue.tooltipOnProcess.list1",
      "dashboard.codValue.tooltipOnProcess.list2"
    );

    this.codValuePerStatus[1].tooltip = this.buildTooltip(
      "dashboard.codValue.tooltipAccepted.list1",
      "dashboard.codValue.tooltipAccepted.list2"
    );
    if (this.deliveryType === "non_cod") {
      this.codValuePerStatus[0].amount = 0;
      this.codValuePerStatus[0].resi = 0;
      this.codValuePerStatus[1].amount = 0;
      this.codValuePerStatus[1].resi = 0;
      return;
    }
    let delay = 0;
    const delayIncrement = 250;
    const requestCodValue = this.codValuePerStatus.map((delivery: any) => {
      delivery.loading = true;
      delay += delayIncrement;
      return new Promise(resolve => {
        setTimeout(resolve, delay);
      }).then(() => {
        DashboardController.getCorporateDashboardDeliveryData({
          path: "/cod/status",
          sttCategory: delivery.type,
          cache: true
        }).then((resp: DataCorporateDashboard) => {
          delivery.loading = false;
          setTimeout(() => {
            delivery.amount = resp.totalCodAmount;
            delivery.resi = resp.totalStt;
          }, 100);
        });
      });
    });
    await Promise.all(requestCodValue);
  }

  buildTooltip(list1Key: string, list2Key: string) {
    return (
      "<ol style='list-style-type: decimal;'>" +
      `<li>${this.$t(list1Key)}</li>` +
      `<li>${this.$t(list2Key)}</li>` +
      "</ol>"
    );
  }

  // nilai cod
  totalCodValue = {
    title: "dashboard.codValue.estTotalCodValue",
    tooltip: "",
    type: "TOTAL_COD_AMOUNT",
    amount: 0,
    resi: 0,
    loading: false
  };
  codValuePerStatus: Array<any> = [
    {
      title: "dashboard.codValue.onProcess",
      tooltip: "",
      type: "IN_PROGRESS",
      amount: 0,
      resi: 0,
      loading: false,
      color: "#FAB713",
      ableToClick: this.ableToViewDetail
    },
    {
      title: "dashboard.codValue.accepted",
      tooltip: "",
      type: "SUCCESS",
      amount: 0,
      resi: 0,
      loading: false,
      color: "#36B37E",
      ableToClick: this.ableToViewDetail
    }
  ];
  valueProgressBar(val: number, maxValue: number) {
    return (val / maxValue) * 100;
  }

  get deliveryType() {
    return DashboardController.filterCorporateDashboard.deliveryType.value;
  }

  get ableToViewDetail() {
    if (IS_SENDER_ACCOUNT) return true;
    return checkRolePermission(TRACK_DELIVERY.ENABLE);
  }
  onClickDetail(dashboardInfo: string) {
    if (!this.ableToViewDetail) return;
    DashboardController.openNewPageFromDashboardCorporate(dashboardInfo);
  }
}
